<template>
  <div class="content">
    <div class="p">How to troubleshoot a reversed CT.</div>

    <div class="p">
      Each CT must be
      <ul class="p">
        <li>Clipped with the <b>arrow pointing the correct direction</b></li>
        <li>CT tails terminated correctly at SolShare CT connector</li>
      </ul>
    </div>

    <div class="p">
      Connection to check:
      <ul class="p">
        <li v-for="(unit, i) in CTReversedUnits" :key="i">{{ unit }}</li>
      </ul>
    </div>

    <back-and-next
      next-text="Next - CT Installation"
      to="/commission/error/reversed-ct-uk/2"
      data-tn="reversed-ct-uk/1"
    >
    </back-and-next>
  </div>
</template>

<script>
import { CommissionErrorMixin } from "../../../../../mixins/commissionError";

export default {
  mixins: [CommissionErrorMixin],
};
</script>

<style scoped lang="less">
.content {
  .p {
    margin-top: 20px;
  }
}
</style>
